import { Box, Tooltip } from '@enechain/ecloud-designsystem'
import { FaCircleQuestionRegular } from '@enechain/ecloud-icons'

import { iconSize } from '~/constants/iconSize'

/**
 * ラベル・見出しの横に置く補足アイコン (`?` + hover tooltip)。
 *
 * 丸アイコンは ⓘ ではなく **`?`** が正 (`design/CLAUDE.md`「補足・ヘルプの丸アイコンは
 * ?」、 DS `FormHelper` が `FaCircleQuestionRegular` を `boxSize 18px` で規定。
 * 2026-08-06 デザイナー判断 #4939)。 寸法は `iconSize.labelHint` (18px)。
 *
 * 需給バランスのフィルタ見出し (doji-bg.md AC-BDB-032) 用に作ったものを、
 * 3 画面目の利用者が出た時点で共有へ昇格させた (`frontend/apps/ebalance/CLAUDE.md`
 * 「複数 page で実際に使われてから共有 directory へ昇格する」)。
 */

type Props = {
  /** tooltip 本文 (spec の文言が SoT)。 */
  content: string
  /** 見出し名を含む説明ラベル (design bg.html の `.head-info` aria-label 相当)。 */
  ariaLabel: string
}

export const HelpIcon = ({ content, ariaLabel }: Props): React.ReactElement => (
  <Tooltip content={content}>
    <Box
      as="span"
      display="inline-flex"
      color="Text.midEmphasis"
      cursor="help"
      // role なしの span に aria-label は付けられない (axe aria-prohibited-attr)。
      // design bg.html の `.head-info` も role="img" + aria-label。
      aria-label={ariaLabel}
      role="img"
      // tooltip の中身に**キーボードだけで到達できる**ようにする
      // (WCAG 2.1 SC 1.4.13 Content on Hover or Focus)。 DS `Tooltip` の trigger は
      // focus で開く (`@zag-js/tooltip` の `onFocus` → `open`) ので、 focusable に
      // すれば hover と同じ内容が読める。 span は既定で focusable ではないため
      // 明示が要る (2026-09-03、 広域マスタ等の同型アイコン 11 箇所を本部品へ
      // 寄せた際に、 移行元が全て持っていた挙動をここへ集約した)。
      tabIndex={0}
    >
      <FaCircleQuestionRegular boxSize={iconSize.labelHint} />
    </Box>
  </Tooltip>
)
